import React from 'react';
import {useParams} from "react-router-dom";
import PageForm from "components/pageForm";
import MissionCreatedContent from "pages/createMission/components/MissionCreatedContent";

// Test page of the wizard's last step, opened from the dashboard outside production.
const MissionCreated = () => {
    const {id} = useParams();
    return (
        <PageForm>
            <div className="px-6 py-10 tab:px-8">
                <MissionCreatedContent missionId={id}/>
            </div>
        </PageForm>
    );
};

export default MissionCreated;
